<div class="modal-header border-bottom-0 px-4 pt-4 d-flex flex-column">
    <h4 class="modal-title" id="modal-basic-title">
        {{ 'hub.console.organizations.update-magaya-connection' | translate }}
    </h4>
</div>

<form (reset)="onReset()" (submit)="onSubmit()" [formGroup]="form">
    <div class="modal-body px-4">
        <h5 class="font-weight-normal">{{ 'hub.console.organizations.superuser' | translate }}</h5>
        <div class="form-group p-fluid mt-3">
            <label for="superuser_username">{{ 'portal.registration.page1.label-username' | translate }}</label>
            <input
                formControlName="superuser_username"
                id="superuser_username"
                maxlength="50"
                pInputText
                placeholder="{{ 'portal.registration.page1.label-username' | translate }}"
            />
            <arv-validation-messages
                for="superuser_username"
            ></arv-validation-messages>
        </div>

        <div class="form-group p-fluid mt-3">
            <label for="superuser_password">{{ 'common.password' | translate }}</label>
            <input
                formControlName="superuser_password"
                id="superuser_password"
                pInputText
                placeholder="{{ 'common.password' | translate }}"
            />
            <arv-validation-messages
                for="superuser_password"
            ></arv-validation-messages>
        </div>

        <div *ngIf="error$ | async; let error" class="alert alert-danger">
            <div class="font-weight-bold">{{ 'common.something_went_wrong' | translate }}</div>
            <div *ngIf="error?.error?.message">
                {{ error?.error.message }}
            </div>
            <div *ngIf="error?.error?.magaya_network_error">{{ error?.error?.magaya_network_error }}</div>
            <div *ngIf="!error?.error?.message">
                {{ 'common.try_again' | translate }}
            </div>
        </div>
    </div>

    <div class="modal-footer px-4 border-top-0 pb-4 pt-0">
        <button
            [disabled]="form.disabled"
            class="btn btn-light mr-2"
            type="reset"
        >
            {{ 'common.cancel' | translate }}
        </button>
        <button
            [disabled]="form.disabled"
            class="btn btn-primary"
            type="submit"
        >
            <fa-icon
                *ngIf="loading$ | async"
                [icon]="['far', 'spinner']"
                [pulse]="true"
                class="mr-1"
            ></fa-icon>
            {{ 'common.update' | translate }}
        </button>
    </div>
</form>
